import api from '../axios'
import {
  CONTACTS,
  TEMPLATES,
  TO_NUMBER,
} from './types';
//
//
//-> Number
//
// Change to number
export const changeToNumber = (number) => async (dispatch) => {

  dispatch({ type: TO_NUMBER, payload: {to: number}});
}
//
//-> Contacts
//
// Get contacts
export const getContacts = () => async (dispatch) => {
  const response = await api.get(`contacts`)

  dispatch({ type: CONTACTS, payload: response.data});
}
//
//-> Templates
//
// Get templates
export const getTemplates = () => async (dispatch) => {
  const response = await api.get(`templates`)

  dispatch({ type: TEMPLATES, payload: response.data});
}